const state = {
    CSRFtoken: '',
    modal: null,
    body: null,
    subscribe: null,
    language: '',
    baseUrl: '',
    cart: null,
    utmSourceCurrent: null,
    utmSourceFirst: null,
    authreg: null,
    scrollPos: 0,
    scT: [],
    userdata: null,
    select2SettlementOptions: null,
    langSelector: null,
    menuclose_flag: false,
    phoneMask: '+38 (099) 999 99 99',
    maskPhoneFormat: '+38 (0__) ___ __ __',
    languagePopupCookie: 'slang_choosed',
    colorScheme: 'light',
    debug: false, // IS not production
};

export function setCommonVars(vars) {
    Object.assign(state, vars);
    window.commonVars = state;
}

export function getCommonVars() {
   return state;
}
